<template>
  <div class="container-fluid">
    <div class="container p-0 card_background_effect">
      <div class="row">
        <div class="col-12 pl-md-0">
          <div class="login-form d-flex">
            <div class="sign-in-sign-up-form w-100">
              <div class="text-center mb-4">
                <img
                    :src="companyInfo.logo ? companyInfo.logo : ''"
                    alt="Logo"
                    class="img-fluid logo"
                    v-if="companyInfo.logo"
                />
                <h6 v-else>{{ companyInfo.company_name }}</h6>
              </div>
              <button class="btn btn-primary no-print " style="position: fixed;right: 3%;top: 10%;"
                      v-on:click="customPrint">Print Form
              </button>
              <!-- Main Form Info Section -->
              <div class="row">
                <div class="col-12 mb-4">
                  <basic-info
                      :basic_info="basicInfo"
                      :yesOrNoList="yesOrNoList"
                      :isAdmin="false"
                  />
                </div>

                <div class="col-12 mb-4">
                  <payroll-info :payroll_info="payrollInfo" :isAdmin="false" />
                </div>

                <div class="col-12 mb-4">
                    <address-info
                      :address_Info="addressInfo"
                      :dateFormatter="dateFormatter"
                      :isAdmin="false"
                      :isReadOnly="true"
                      :onSaveBtn="saveBtnHandler"
                      :hide-read-more="true"
                      :restrict-validation="false"
                    />
                </div>

                <!-- Uploaded Documents Section -->
                <div class="col-12 mb-4">
                  <div v-for="(files, category) in uploadedDocuments" :key="category" class="mb-5">
                    <h4 class="border-bottom pb-2 mb-3">{{ formatCategory(category) }}</h4>

                    <div class="row">
                      <div
                          v-for="(file, index) in files"
                          :key="index"
                          class="col-12 mb-4"
                      >
                        <el-card shadow="always" class="w-100">
                          <div class="mb-2">
                            <strong>{{ file.file_name }}</strong><br />
                            <small>{{ formatDate(file.updated_at) }}</small>
                          </div>

                          <!-- Profile Picture Handling -->
                          <img
                              v-if="file.type === 'profile_pic' && file.file_path"
                              :src="'/' + file.file_path"
                              alt="Profile Picture"
                              class="rounded-circle mb-3"
                              style="max-width: 150px; height: auto;"
                          />

                          <!-- Only show file_path image if pdf_images doesn't exist and it's not a profile_pic -->
                          <img
                              v-else-if="file.file_path && !parsePdfImages(file.pdf_images).length"
                              :src="'/' + file.file_path"
                              alt="Applicant File"
                              class="img-fluid print-image mb-3"
                          />

                          <!-- Show parsed PDF images if they exist -->
                          <div v-if="file.pdf_images" class="pdf-images">
                            <img
                                v-for="(imgPath, idx) in parsePdfImages(file.pdf_images)"
                                :key="idx"
                                :src="`/${imgPath}`"
                                alt="PDF Page"
                                class="img-fluid print-image mb-3"
                            />
                          </div>
                        </el-card>
                      </div>
                    </div>
                  </div>
                </div>


                <!-- Remaining Info Sections -->
                <div class="col-12 mb-4">
                  <training-info
                      :yesOrNoList="yesOrNoList"
                      :training_info="trainingInfo"
                      :dateFormatter="dateFormatter"
                      :onSaveBtn="saveBtnHandler"
                      :isReadOnly="true"
                      :isAdmin="false"
                  />
                </div>

                <div class="col-12 mb-4">
                  <candidate-history
                      :candidate_history_info="candidateHistoryInfo"
                      :emailAddress="basicInfo.email"
                      :dateFormatter="dateFormatter"
                      :onSaveBtn="saveBtnHandler"
                      :isReadOnly="true"
                      :isAdmin="false"
                  />
                </div>

                <div class="col-12 mb-4 break-after">
                  <sia-info :sia_Info="siaInfo" :isAdmin="false" />
                </div>

                <div class="col-12 mb-4">
                  <h3 class="text-center mb-0">Policy and Declaration</h3>
                  <policy-declaration-info :policy_declaration="policyDeclarationInfo" :companyInfo="companyInfo"
                                         :yesOrNoList="yesOrNoList"
                                         :isAdmin="false"/>
                  <div class="col-6 mb-2">
                    <div class="row">
                       <label class="col-sm-12 mb-sm-0 pl-0">
                      Applicant Signature:
                    </label>
                    <div class="col-12 pl-0">
                       <div v-if="signatureSaved && gdprInfo.signature" style="border: dashed 0.5px;">
                      <img :src="gdprInfo.signature" alt="Signature" width="400px" class="img-fluid">
                       <div class="mt-2 no-print">
                        <button
                            @click.prevent="startEditSignature"
                            class="btn btn-outline-primary btn-sm"
                        >
                          Update Signature
                        </button>
                      </div>
                   </div>
                    <!-- Signature pad (first time OR when editing) -->
                      <div v-else class="no-print">
                        <VueSignaturePad ref="signaturePad"
                                         width="100%"
                                         height="200px"
                                         :options="options"
                                         style="border: dashed 0.5px;"
                                         :required="true" />
                        <div class="mt-2">
                          <button @click.prevent="clearSignature" class="btn btn-danger mr-2">
                            Undo
                          </button>
                          <button @click.prevent="saveSignature" class="btn btn-success mr-2">
                            Save
                          </button>
                          <button
                              v-if="gdprInfo.signature"
                              @click.prevent="cancelEditSignature"
                              class="btn btn-secondary"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                   </div>
                    </div>
                  </div>
                  <div class="col-6 mb-2">
                    <div class="row">
                        <label class="col-sm-12 mb-sm-0 pl-0">Date</label>
                         <app-input class="col-sm-12 pl-0"
                             type="date"
                             v-model="gdprInfo.consent_date_time"
                             placeholder=""/>
                    </div>
                  </div>
                </div>


                <div class="col-12 mb-4">
                  <gdpr-notice-info :gdpr_info="gdprInfo" :isAdmin="false" />
                </div>
              </div> <!-- .row end -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

import {SCREENING_USER_REGISTRATION} from '../../../../../../js/app/Config/ScreeningAppUrl';
import {FormMixin} from "../../../../../core/mixins/form/FormMixin.js";
import {AuthMixin} from "../../Auth/Mixins/AuthMixin";
import moment from "moment";
import {_yesOrNoList} from '@Views/Screening/utility/constant';
import {dateFormatter, checkPolicyDeclaration} from '@Views/Screening/utility/common';
import {Candidate} from "@Views/Screening/utility/apiAgent";
import {axiosGet} from "@/app/Helpers/AxiosHelper";
import * as actions from "@/app/Config/ApiUrl";

export default {
  name: "ApplicationForm",
  mixins: [FormMixin, AuthMixin],
  props: {
    applicant: Object,
    screeningSchedule: Object,
    uploadedDocuments: Object,
    applicantSearches: Object,
    previousHistory: Object,

  },
  mounted() {
    this.companyInfo = this.screeningSchedule?.company;
    this.configData = this.screeningSchedule?.company;
    $("._remove_class").removeClass("el-button");
    this.getApplicantDetails();
    $("body").click(function () {
    });
  },
  created() {
    this.setPolicyDeclarationFields();
    this.is_consent_modal = true;

  },
  data() {
    return {
      companyInfo: {},
      showCompletedStatus: false,
      is_consent_modal: false,
      basicInfo: {},
      payrollInfo: {},
      addressInfo: [],
      trainingInfo: [],
      candidateHistoryInfo: [],
      siaInfo: [],
      policyDeclarationInfo: {},
      gdprInfo: {},
      nextButton: false,
      active: 0,
      preloader: false,
      registrationForm: {},
      activeIdCollection: [],
      yesOrNoList: _yesOrNoList,
      emailAddress: '',
      maxStep: 7,
      isEditingSignature: false,
      signatureSaved: false,
      options: {
        penColor: "#000",
      },

    };
  },
  methods: {
    saveBtnHandler() {

    },
    parsePdfImages(images) {
      if (typeof images === 'string') {
        try {
          return JSON.parse(images);
        } catch (e) {
          console.error('Invalid JSON in pdf_images:', e);
          return [];
        }
      }
      return Array.isArray(images) ? images : [];
    },
    customPrint() {

      // Print after a short delay to ensure the class is applied
      setTimeout(() => {
        window.print();
      }, 100);
    },
    formatCategory(key) {
      return key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    },
    dateFormatter,
    checkPolicyDeclaration,
    next() {
      const isValidated = this.validator();
      if (isValidated == false) {
        return;
      }
      if (this.active === this.maxStep) {

        return;
      }
      let nextStep = this.active++;
      if (nextStep > this.maxStep) {
        this.active = 1;
      }
      this.activeIdCollection.push(this.active);
      $("#_remove_class_").removeClass("el-button");
      this.saveBtnHandler();
    },
    validator() {
      const lastIndex = (this.activeIdCollection.length - 1) === -1 ? 0 : (this.activeIdCollection.length - 1);
      if (this.activeIdCollection[lastIndex] === 2) {
        const isValid = this.addressHistoryValidation();
        return isValid;
      }
      if (this.activeIdCollection[lastIndex] === 4) {
        const isValid = this.candidateHistoryValidation();
        return isValid;
      }
      return true;
    },
    addressHistoryValidation() {
      if (this.addressInfo.length > 0) {
        const firstIterationToDate = this.addressInfo[0].to_date;
        const addressLastIndex = (this.addressInfo.length - 1) === -1 ? 0 : (this.addressInfo.length - 1);
        const lastIterationFromDate = this.addressInfo[addressLastIndex].from_date;
        const startDate = moment(lastIterationFromDate);
        const endDate = moment(firstIterationToDate);
        const yearsDiff = endDate.diff(startDate, 'years');
        if (yearsDiff < 3) {
          this.$toastr.i('You need to enter address history for last 3 years.');
          //return false;
        }
        return true;
      }
      // return false;
    },
    candidateHistoryValidation() {
      if (this.candidateHistoryInfo.length > 0) {
        const firstIterationToDate = this.candidateHistoryInfo[0].to_date;
        const candidateHistoryLastIndex = (this.candidateHistoryInfo.length - 1) === -1 ? 0 : (this.candidateHistoryInfo.length - 1);
        const lastIterationFromDate = this.candidateHistoryInfo[candidateHistoryLastIndex].from_date;
        const startDate = moment(lastIterationFromDate);
        const endDate = moment(firstIterationToDate);
        const yearsDiff = endDate.diff(startDate, 'years');
        if (yearsDiff < 5) {
          this.$toastr.i('You need to enter history for last 5 years.');
          //return false;
        }
        return true;
      }
      // return false;
    },
    previous() {
      if (this.active-- < this.maxStep) this.active = this.active--;
      if(this.active < 8){
        this.showCompletedStatus = false
      }
    },
    stepClick(_, id) {
      const isValidated = this.validator();
      if (isValidated == false) {
        return;
      }
      this.activeIdCollection.push(id);
      this.active = id;
    },
    beforeSubmit() {
      this.preloader = true;
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);

      this.$emit('afterSubmitDone');
    },
    afterFinalResponse() {
      this.preloader = false;
      this.registrationForm = {};
    },
    afterError() {
      this.preloader = false;
    },

    getEmailFromQueryString() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      return params.email ?? false;

    },
    getApplicantDetails() {
      if (this.applicant && Object.values(this.applicant).length > 0) {
        this.setApiResponseIntoBasicInfoProps(this.applicant, this.applicant.files);
        this.setApiResponseIntoPayrollProps(this.applicant?.applicant_payroll);
        this.setApiResponseIntoPolicyDeclrationProps(this.applicant?.applicant_policy_declaration);
        this.setApiResponseIntoGdprProps(this.applicant?.applicant_gdpr_detail, this.applicant.company);
        this.setApiResponseIntoTrainingProps(this.applicant?.applicant_training);
        this.setApiResponseIntoAddressProps(this.applicant?.applicant_address);
        this.setApiResponseIntoSIAProps(this.applicant?.applicant_sia_detail);
        this.setApiResponseIntoPreviousHistoryProps({
          employment: this.applicant?.applicant_employment,
          education: this.applicant?.applicant_education,
          selfEmployment: this.applicant?.applicant_self_employment,
          unEmployment: this.applicant?.applicant_unemployment,
          applicantEmail: this.applicant?.email,
        });
      }
    },
    setApiResponseIntoBasicInfoProps(applicant, files = null) {
      this.$set(this.basicInfo, 'employee_picture_path', null);
      this.$set(this.basicInfo, 'employee_picture_name', null);
      this.$set(this.basicInfo, 'pending_profile_pic', null);
      this.$set(this.basicInfo, 'employeeImagePreview', null);
      this.$set(this.basicInfo, 'passport_path', null);
      this.$set(this.basicInfo, 'passport_name', null);
      this.$set(this.basicInfo, 'pending_passport', null);
      this.$set(this.basicInfo, 'passportPreview', null);
      this.$set(this.basicInfo, 'driving_license_path', null);
      this.$set(this.basicInfo, 'driving_license_name', null);
      this.$set(this.basicInfo, 'pending_driving_license', null);
      this.$set(this.basicInfo, 'drivingLicensePreview', null);
      this.$set(this.basicInfo, 'driving_license_document', null);
      this.$set(this.basicInfo, 'passport', null);
      this.$set(this.basicInfo, 'employee_picture', null);

      if (files && Array.isArray(files)) {
        const profilePic = files.filter(f => f.type === 'profile_pic').reduce((prev, current) => {
          return (Number(current.id) > (Number(prev?.id) || 0)) ? current : prev;
        }, null);
        
        if (profilePic) {
          this.$set(this.basicInfo, 'employee_picture_path', profilePic.file_path);
          this.$set(this.basicInfo, 'employee_picture_name', profilePic.file_name);
          this.$set(this.basicInfo, 'employee_picture_id', profilePic.id);
        }

        const passportFile = files.filter(f => f.type === 'passport').reduce((prev, current) => {
          return (Number(current.id) > (Number(prev?.id) || 0)) ? current : prev;
        }, null);

        if (passportFile) {
          this.$set(this.basicInfo, 'passport_path', passportFile.file_path);
          this.$set(this.basicInfo, 'passport_name', passportFile.file_name);
          this.$set(this.basicInfo, 'passport_id', passportFile.id);
        }

        const drivingLicenseFile = files.filter(f => f.type === 'driving_license').reduce((prev, current) => {
          return (Number(current.id) > (Number(prev?.id) || 0)) ? current : prev;
        }, null);

        if (drivingLicenseFile) {
          this.$set(this.basicInfo, 'driving_license_path', drivingLicenseFile.file_path);
          this.$set(this.basicInfo, 'driving_license_name', drivingLicenseFile.file_name);
          this.$set(this.basicInfo, 'driving_license_id', drivingLicenseFile.id);
        }
      }

      this.$set(this.basicInfo, 'position_applied', applicant.position_applied);
      this.$set(this.basicInfo, 'full_name', applicant.full_name);
      this.$set(this.basicInfo, 'forename', applicant.forename);
      this.$set(this.basicInfo, 'middle_name', applicant.middle_name);
      this.$set(this.basicInfo, 'surname', applicant.surname);
      this.$set(this.basicInfo, 'n_i_number', applicant.n_i_number);
      this.$set(this.basicInfo, 'gender', applicant.gender);
      this.$set(this.basicInfo, 'date_of_birth', applicant.date_of_birth);
      this.$set(this.basicInfo, 'title', applicant.title);
      this.$set(this.basicInfo, 'country_of_birth', applicant.country_of_birth);
      this.$set(this.basicInfo, 'town_of_birth', applicant.town_of_birth);
      this.$set(this.basicInfo, 'photo_id_match', applicant.photo_id_match);
      this.$set(this.basicInfo, 'nationality', applicant.nationality);
      this.$set(this.basicInfo, 'edbs_number', applicant.edbs_number);
      this.$set(this.basicInfo, 'contact_number', applicant.contact_number ?? '');
      this.$set(this.basicInfo, 'alternative_contact_no', applicant.alternative_contact_no ?? '');
      this.$set(this.basicInfo, 'email', applicant.report_email === 'primary'? applicant.email : applicant.additional_email);
      this.$set(this.basicInfo, 'additional_email', applicant.additional_email);
      this.$set(this.basicInfo, 'download_application', true);
      this.$set(this.basicInfo, 'report_email', applicant.report_email);
      this.$set(this.basicInfo, 'relationship', applicant.relationship);
      this.$set(this.basicInfo, 'next_of_kin', applicant.next_of_kin);
      this.$set(this.basicInfo, 'next_of_kin_contact_no', applicant.next_of_kin_contact_no ?? '');
      this.$set(this.basicInfo, 'is_sia_required', applicant.is_sia_required === 1 ? true : false);
      this.$set(this.basicInfo, 'sia_license_number', applicant.sia_license_number);
      this.$set(this.basicInfo, 'sia_license_type', applicant.sia_license_type);
      this.$set(this.basicInfo, 'sia_license_expiry', applicant.sia_license_expiry);
      this.$set(this.basicInfo, 'is_additional_license', applicant.is_additional_license === 1 ? true : false);
      this.$set(this.basicInfo, 'additional_sia_license_number', applicant.additional_sia_license_number);
      this.$set(this.basicInfo, 'additional_sia_license_type', applicant.additional_sia_license_type);
      this.$set(this.basicInfo, 'additional_sia_license_expiry', applicant.additional_sia_license_expiry);
      this.$set(this.basicInfo, 'share_code', applicant.share_code);
      this.$set(this.basicInfo, 'share_code_start_date', applicant.share_code_start_date);
      this.$set(this.basicInfo, 'employee_picture', applicant.employee_picture);
      this.$set(this.basicInfo, 'is_visa_require_uk', applicant.is_visa_require_uk);
      this.$set(this.basicInfo, 'visa_type', applicant.visa_type);
      this.$set(this.basicInfo, 'biometric_residence_permit', applicant.biometric_residence_permit);
      this.$set(this.basicInfo, 'visa_expiry', applicant.visa_expiry);
      this.$set(this.basicInfo, 'date_of_entry_re_entry', applicant.date_of_entry_re_entry);
      this.$set(this.basicInfo, 'is_have_p45_or_p46', applicant.is_have_p45_or_p46);
      this.$set(this.basicInfo, 'copy_of_p45', applicant.copy_of_p45);
      this.$set(this.basicInfo, 'p46_detail', applicant.p46_detail);
      this.$set(this.basicInfo, 'is_other_employment', applicant.is_other_employment);
      this.$set(this.basicInfo, 'continue_other_employment', applicant.continue_other_employment);
      this.$set(this.basicInfo, 'is_leisure', applicant.is_leisure);
      this.$set(this.basicInfo, 'leisure_details', applicant.leisure_details);
      this.$set(this.basicInfo, 'is_criminal_record', applicant.is_criminal_record);
      this.$set(this.basicInfo, 'criminal_record_details', applicant.criminal_record_details);
      this.$set(this.basicInfo, 'is_bankruptcy', applicant.is_bankruptcy);
      this.$set(this.basicInfo, 'bankruptcy_details', applicant.bankruptcy_details);
      this.$set(this.basicInfo, 'is_days_shift_cant_work', applicant.is_days_shift_cant_work);
      this.$set(this.basicInfo, 'days_shift_cant_work_details', applicant.days_shift_cant_work_details);
      this.$set(this.basicInfo, 'is_holidays_commitment', applicant.is_holidays_commitment);
      this.$set(this.basicInfo, 'holidays_commitment_details', applicant.holidays_commitment_details);
      this.$set(this.basicInfo, 'is_own_vehicle', applicant.is_own_vehicle);
      this.$set(this.basicInfo, 'is_driving_license', applicant.is_driving_license);
      this.$set(this.basicInfo, 'driver_license_number', applicant.driver_license_number);
      this.$set(this.basicInfo, 'license_type', applicant.license_type);
      this.$set(this.basicInfo, 'license_issue_date', applicant.license_issue_date);
      this.$set(this.basicInfo, 'license_expiry_date', applicant.license_expiry_date);
      if (applicant.licenses && Array.isArray(applicant.licenses) && files && Array.isArray(files)) {
        const cleanedLicenses = applicant.licenses.map(license => {
          if (license.license_id) {
            const fileExists = files.some(f => f.id == license.license_id);
            if (!fileExists) {
              return {
                ...license,
                license_id: null,
                license_path: null,
                license_name: null,
                licensePreview: null,
                pending_license_document: null,
                license_document: null
              };
            }
          }
          return license;
        });
        this.$set(this.basicInfo, 'licenses', cleanedLicenses);
      } else {
        this.$set(this.basicInfo, 'licenses', applicant.licenses);
      }
    },
    setApiResponseIntoPayrollProps(payroll) {
      if (payroll && Object.values(payroll).length > 0) {
        this.$set(this.payrollInfo, 'account_name', payroll.account_name);
        this.$set(this.payrollInfo, 'account_number', payroll.account_number);
        this.$set(this.payrollInfo, 'bank_name', payroll.bank_name);
        this.$set(this.payrollInfo, 'other_information', payroll.other_information);
        this.$set(this.payrollInfo, 'sort_code', payroll.sort_code);
      }
    },
    setApiResponseIntoAddressProps(address) {
      if (address && address.length > 0) {
        this.addressInfo = address;
      }
    },
    setApiResponseIntoTrainingProps(training) {
      if (training && training.length > 0) {
        this.trainingInfo = training;
      }
    },
    setApiResponseIntoPreviousHistoryProps(previousHistory) {
      if (previousHistory.employment && previousHistory.employment.length > 0) {
        for (const employment of previousHistory.employment) {
          this.candidateHistoryInfo.push({...employment, type: 0});
        }
      }
      if (previousHistory.education && previousHistory.education.length > 0) {
        for (const education of previousHistory.education) {
          this.candidateHistoryInfo.push({...education, type: 1});
        }
      }
      if (previousHistory.selfEmployment && previousHistory.selfEmployment.length > 0) {
        for (const selfEmployment of previousHistory.selfEmployment) {
          this.candidateHistoryInfo.push({...selfEmployment, type: 2});
        }
      }
      if (previousHistory.unEmployment && previousHistory.unEmployment.length > 0) {
        for (const unEmployment of previousHistory.unEmployment) {
          this.candidateHistoryInfo.push({...unEmployment, type: 3});
        }
      }
    },
    setApiResponseIntoSIAProps(sia) {
      if (sia && sia.length > 0) {
        this.siaInfo = sia
      }
    },
    setApiResponseIntoGdprProps(gdpr, company) {
      if (gdpr && Object.values(gdpr).length > 0) {

        this.$set(this.gdprInfo, 'consent', gdpr.consent === 1 ? true : false);
        this.$set(this.gdprInfo, 'consent_date_time', gdpr.consent_date_time);
        this.$set(this.gdprInfo, 'special_category_data', gdpr.special_category_data === 1 ? true : false);
        this.$set(this.gdprInfo, 'signature', gdpr.signature);
        this.signatureSaved = !!gdpr.signature;
        this.isEditingSignature = false;
        // Ensure individual special-category checkbox fields are populated
        this.$set(this.gdprInfo, 'criminal', !!gdpr.criminal);
        this.$set(this.gdprInfo, 'financial', !!gdpr.financial);
        this.$set(this.gdprInfo, 'health', !!gdpr.health);
        this.$set(this.gdprInfo, 'diversity', !!gdpr.diversity);
        this.$set(this.gdprInfo, 'biometric', !!gdpr.biometric);
        this.$set(this.gdprInfo, 'companyInfo', company);
      }
    },
    setApiResponseIntoPolicyDeclrationProps(policyDeclration) {
      if (policyDeclration && Object.values(policyDeclration).length > 0) {
        this.$set(this.policyDeclarationInfo, 'applicant_screening', policyDeclration.applicant_screening === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'criminal_background_check', policyDeclration.criminal_background_check === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', policyDeclration.declaration_by_applicant === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'financial_history', policyDeclration.financial_history === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality', policyDeclration.equality === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality_details', policyDeclration.equality_details);
        this.$set(this.policyDeclarationInfo, 'working_time_directive', policyDeclration.working_time_directive);
      }
    },
    closeModal() {
      this.is_consent_modal = false;
      $("#consent-modal").modal("hide");
    },
    acceptAll() {
      this.$set(this.policyDeclarationInfo, 'applicant_screening', true);
      this.$set(this.policyDeclarationInfo, 'criminal_background_check', true);
      this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', true);
      this.$set(this.policyDeclarationInfo, 'financial_history', true);
      this.$set(this.policyDeclarationInfo, 'equality', true);
      this.$set(this.policyDeclarationInfo, 'working_time_directive', 'yes');
      setTimeout(() => {
        this.closeModal()
      }, 1000 )

    },
    setPolicyDeclarationFields(){
      this.$set(this.policyDeclarationInfo, 'applicant_screening', false);
      this.$set(this.policyDeclarationInfo, 'criminal_background_check',  false);
      this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', false);
      this.$set(this.policyDeclarationInfo, 'financial_history', false);
      this.$set(this.policyDeclarationInfo, 'equality', false);
      this.$set(this.policyDeclarationInfo, 'working_time_directive', 'no');
    },
    confirmSubmission(lastFormIndex) {
      if (confirm("Are you sure all the information is correct and you want to submit? You may cancel and go back to review your information." )) {
        return true; // Proceed with submission
      } else {
        this.active = 0; // Take the user back to the previous step for review
        return false;
      }
    },
    startEditSignature() {
      this.isEditingSignature = true;
      this.signatureSaved = false;
      this.$nextTick(() => {
        if (this.$refs.signaturePad) {
          this.$refs.signaturePad.clearSignature
              ? this.$refs.signaturePad.clearSignature()
              : this.$refs.signaturePad.clear();
        }
      });
    },
    cancelEditSignature() {
      this.isEditingSignature = false;
      this.signatureSaved = !!this.gdprInfo.signature;
    },
    clearSignature() {
      this.$refs.signaturePad.undoSignature();
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.$set(this.gdprInfo, 'signature', data);
        this.isEditingSignature = false;
        this.signatureSaved = true;
      }
    },
  },
  computed: {
    lastFormIndex(){
      return this.activeIdCollection.at(-1)
    },
    isMobile() {
      let width = window.innerWidth;
      let stepsDirection;
      // Set to vertical on small screens (less than 768px)
      if (width <= 768) {
        stepsDirection = 'vertical';
      } else {
        stepsDirection = 'horizontal';
      }
      return stepsDirection;
    },
    addUrl(){
      // Get the full URL from the browser's location
      let url = window.location.href;

// Split the URL by the '?' to separate the path from the query string
      let urlParts = url.split('?');

// Extract the part before the query string (the path)
      let path = urlParts[0];

// Split the path by '/' to get each segment
      let pathSegments = path.split('/');

// Assuming the encryptedCompanyKey is the last segment in the path
      let encryptedCompanyKey = pathSegments[pathSegments.length - 1];

// Output or use the encryptedCompanyKey
      return SCREENING_USER_REGISTRATION + '/'+encryptedCompanyKey;
    }
  }
}
</script>
<style>
.scroll-container {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  /* This ensures items stay in a single line */
}

.scroll-content {
  /* display: inline-block; */
  /* Ensures the container only takes as much width as its children */
}

/* Hide scrollbar */
.scroll-container::-webkit-scrollbar {
  display: none;
}

.el-step.is-horizontal .el-step__main .el-step__title {
  /* font-size: 14px !important; */
  padding-right: 14px !important;
  cursor: pointer;
}

.el-step__title {
  font-size: 12px !important;
  line-height: 40px !important;
  color: #292f4c !important;
}

.el-step__head.is-process .el-step__icon.is-text {
  /* background-color: #292f4c !important; */
  color: #292f4c !important;
  border-color: #292f4c !important;
}

.el-step__head.is-finish {
  color: #292f4c !important;
  border-color: #292f4c !important;
}
.el-step__head.is-finish .el-step__line .el-step__line-inner {
  border-color: #292f4c !important;
}

.el-step__head.is-finish .el-step__icon.is-text {
  background-color: #292f4c !important;
  color: white !important;
  border-color: #C0C4CC !important;
}
.el-step__head.is-finish .el-step__icon .el-step__icon-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #292f4c !important; */
  color: #fff !important;
  /* border-color: #292f4c !important; */
  position: relative;
}

/* Hide the original number by setting its content to nothing */
.el-step__head.is-finish .el-step__icon .el-step__icon-inner::before {
  content: '\2713'; /* Unicode for checkmark */
  font-size: 16px !important;
  font-weight: bold;
}

/* Make sure to hide any existing text inside the icon */
.el-step__head.is-finish .el-step__icon .el-step__icon-inner {
  content: ""; /* Remove any existing text */
  font-size: 0; /* Ensures no step number shows */
}

/* Need to set this CSS its not working here. */
/* .el-step.is-horizontal .el-step__main .el-step__title {
  font-size: 14px !important;
  padding-right: 14px !important;
  cursor: pointer;
} */
.print-image {
  width: 100%;
  margin-bottom: 15px;
}

@media print {
  /* Increase overall font size for better readability */
  body, p, span, div, label, input, textarea, select {
    font-size: 14px !important;
  }

  /* Add spacing between questions and radio buttons */
  .form-group {
    margin-bottom: 18px !important;
  }

  label {
    font-size: 14px !important;
    margin-bottom: 8px !important;
    margin-top: 8px !important;
  }

  /* Add spacing around radio button groups */
  .customized-radio {
    margin-top: 11px !important;
    margin-bottom: 8px !important;
  }

  /* Fix radio button circle alignment with text */
  .customized-radio .outside {
    top: 6px !important;
    margin-top: 0 !important;
  }

  .print-image {
    page-break-after: always;
  }

  .break-before {
    page-break-before: always;
  }

  .break-after {
    page-break-after: always;
  }

  .no-break-inside {
    page-break-inside: avoid;
  }
  .no-print {
    display: none !important;
    visibility: hidden !important;
  }

  @page {
    margin: 35px 15px;
  }

  /* Fix for AppInput SingleCheckbox printing */
  .customized-checkbox input:checked + label:after {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    background: #000 !important;
    box-shadow: 2px 0 0 #000, 4px 0 0 #000, 4px -2px 0 #000, 4px -4px 0 #000, 4px -6px 0 #000, 4px -8px 0 #000 !important;
  }

  .customized-checkbox input + label:before {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    border-color: #000 !important;
  }

  /* Fix for customized-radio printing */
  .customized-radio .outside {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    border: 1px solid #000 !important;
    display: inline-block !important;
    width: 22px !important;
    height: 22px !important;
    border-radius: 50% !important;
    position: relative !important;
  }

  .customized-radio input:checked + .outside .inside {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    background: #000 !important;
    display: inline-block !important;
    width: 10px !important;
    height: 10px !important;
    border-radius: 50% !important;
    position: absolute !important;
    top: 5px !important;
    left: 5px !important;
    transform: scale(1, 1) !important;
  }
}
</style>
